import React from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import "./footer.css";
import { CallOutlined, EmailRounded } from "@mui/icons-material";

const Footer = () => {
  return (
    <div className="footer_div">
      <div className="footer_icons">
        <a
          href="https://www.facebook.com/profile.php?id=100009107967867"
          target="_blank"
          rel="noreferrer"
          style={{ color: "black" }}
        >
          <FacebookIcon id="social_id" style={{ color: "white" }} />
        </a>
        <a
          href="https://www.instagram.com/debabratabasak061/"
          target="_blank"
          rel="noreferrer"
          style={{ color: "black" }}
        >
          <InstagramIcon id="social_id" style={{ color: "white" }} />
        </a>

        <a
          href="https://github.com/CoderBoy061"
          target="_blank"
          rel="noreferrer"
          style={{ color: "black" }}
        >
          <GitHubIcon id="social_id" style={{ color: "white" }} />
        </a>
        <a
          href="https://www.linkedin.com/in/debabrata-basak-3925841b6/"
          target="_blank"
          rel="noreferrer"
          style={{ color: "black" }}
        >
          <LinkedInIcon id="social_id" style={{ color: "white" }} />
        </a>
      </div>
      <div className="person_contacts_info">
        <div className="personal_contact__div">
          <EmailRounded style={{ color: "white" }} />
          <p>debabratabasak061@gmail.com</p>
        </div>
        <div className="personal_contact__div">
          <CallOutlined style={{ color: "white" }} />
          <p>8348708604</p>
        </div>
      </div>
      <p className="copyright">Copyright @2023-@2024 All Rights Reserved</p>
    </div>
  );
};

export default Footer;
